import { render } from "./DistributorList.vue?vue&type=template&id=ab9a63d2&scoped=true"
import script from "./DistributorList.js?vue&type=script&lang=js&external"
export * from "./DistributorList.js?vue&type=script&lang=js&external"

import "./DistributorList.scss?vue&type=style&index=0&id=ab9a63d2&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab9a63d2"]])

export default __exports__